import React from "react";
import { cn } from "@/lib/utils";

interface BorderedIconWrapperProps {
  children: React.ReactNode;
  className?: string;
}

const BorderedIconWrapper: React.FC<BorderedIconWrapperProps> = ({
  children,
  className,
}) => {
  return (
    <div
      className={cn(
        "w-8 h-8 border border-[#C1D1EB] dark:border-primary-700 rounded-md flex items-center justify-center",
        className
      )}>
      {children}
    </div>
  );
};

export default BorderedIconWrapper;
